import { OperationItemsBaseModel } from './operation-items-base-model';

export class OperationAuditModel extends OperationItemsBaseModel {
  beginDate: Date|null;
  endDate: Date|null;
  auditReportFileId: string|null;
  onePageReportsFileId: string|null;
}
